"use strict";
$(function () {

    if (window.location.pathname !== "/tellimine/") {
        return false;
    }

    /************************** INITIAL ACTIONS ***************************/

    const packet_selection_raw = sessionStorage.getItem('packet_selection');

    if (packet_selection_raw != null) {
        const packet_selection = JSON.parse(packet_selection_raw);
        $('input[name="packet_id"]').val(packet_selection.packet_id);
        $('input[name="packet_slug"]').val(packet_selection.packet_label);
        $('input[name="packet_price"]').val(packet_selection.price_input);
        $('input[name="additional_services"]').val(JSON.stringify(packet_selection.additional_services));
    } else {
        window.location.href = '../#teenused-ja-paketid';
    }

    /************************* BUTTONS ACTIONS ******************************/

    function clearErrors(){
        $('.fields-not-validated-container').addClass('hide');
        $('#order-form .not-validated').each((key, input)=>{
            $(input).removeClass('not-validated');
        })
    }

    $('.order-buttons .forward').click(function (e) {
        e.preventDefault();

        const $form = $('#order-form');

        const active_section = $form.find(".active-section");
        const section_index = parseInt(active_section.attr('id').split('-')[1]);
        const $active_breadcrumb = $(".section-"+section_index)

        const new_section_index = section_index + 1;

        clearErrors();

        if ($(this).hasClass('locked') && !validateSection(section_index)) {
            if (new_section_index === 3 && $('.not-validated').length > 0) {
                $('.fields-not-validated-container').removeClass('hide');
                document.getElementById("fields-error").scrollIntoView();
            }else{
                $('.fields-not-validated-container').addClass('hide');
            }
            return;
        } else {
            $('.fields-not-validated-container').addClass('hide');
        }

        const $next_section = $("#section-"+new_section_index);
        const $next_breadcrumb = $(".section-"+new_section_index);

        $('.active-section').removeClass('active-section').addClass('hide');
        $active_breadcrumb.addClass('validated');
        $active_breadcrumb.removeClass('selected');
        $next_breadcrumb.addClass('selected');
        $next_section.addClass('active-section').removeClass('hide');

        const $back_button = $('.order-buttons .back');

        if ($back_button.hasClass('hide'))
            $back_button.removeClass('hide');

        if (new_section_index === 4){
            $('.order-buttons .back').addClass('hide');
            $(this).addClass('hide');
        }
        else if (new_section_index === 3) {
            $(this).addClass('hide');
            $('.order-buttons .confirm').removeClass('hide');
            $("#order-form").submit();
        }


        $('html, body').animate({
            scrollTop: $form.offset().top - $('#masthead').height()
        }, 200);
        $(this).addClass('locked');
    });

    $('.order-buttons .back').click(function (e) {
        e.preventDefault();

        /*if ($(this).hasClass('locked'))
            return;*/

        const $form = $('#order-form');

        const active_section = $form.find(".active-section");
        let section_index = parseInt(active_section.attr('id').split('-')[1]);
        const $active_breadcrumb = $(".section-"+section_index);

        const new_section_index = section_index - 1;

        const $last_section = $("#section-"+new_section_index);
        const $last_breadcrumb = $(".section-"+new_section_index);

        $('.active-section').removeClass('active-section').addClass('hide');
        $active_breadcrumb.removeClass('selected');
        $last_breadcrumb.removeClass('validated');
        $last_breadcrumb.addClass('selected');
        $last_section.addClass('active-section').removeClass('hide');

        const $back_button = $('.order-buttons .back');

        if ($back_button.hasClass('hide'))
            $back_button.removeClass('hide');

        if (!$('.order-buttons .confirm').hasClass('hide')) {
            $('.order-buttons .confirm').addClass('hide');
            $('.order-buttons .forward').removeClass('hide');
        }

        if (new_section_index === 1)
            $(this).addClass('hide');

        $('html, body').animate({
            scrollTop: $form.offset().top - $('#masthead').height()
        }, 200);

        $()

    });

    $('.order-buttons .confirm').click(function (e) {
        e.preventDefault();

        if ($(this).hasClass('locked')) {

            if ($('input[name="ch1"]:checked').length === 0) {

                $('input[name="ch1"]').addClass('not-validated');

                $('.fields-not-validated-container').html('Edasiliikumiseks on vaja nõustuda teenuse kasutamise tingimustega!');
                $('.fields-not-validated-container').removeClass('hide');
            }
            return;
        }

        $('body').addClass('registering_order');

        if ($('input[name="ch3"]:checked').length !== 0) {
            orderData['add_newsletter'] = true;
        }

        let template_data = {
            action: 'register_order',
            data: orderData
        };


        $.post(myAjax.ajaxurl, template_data, function(response) {

            const res = JSON.parse(response);

            if (res.status) {

                console.log(res);

                generatePaymentPage(res.data);

                const $form = $('#order-form');

                const active_section = $form.find(".active-section");
                const section_index = parseInt(active_section.attr('id').split('-')[1]);
                const $active_breadcrumb = $(".section-"+section_index);

                const new_section_index = section_index + 1;

                const $next_section = $("#section-"+new_section_index);
                const $next_breadcrumb = $(".section-"+new_section_index);

                $('.active-section').removeClass('active-section').addClass('hide');
                $active_breadcrumb.removeClass('selected');
                $active_breadcrumb.addClass('validated');
                $next_breadcrumb.addClass('selected');
                $next_section.addClass('active-section').removeClass('hide');

                const $back_button = $('.order-buttons .back');

                if (!$back_button.hasClass('hide'))
                    $back_button.addClass('hide');

                if (!$('.order-buttons .confirm').hasClass('hide'))
                    $('.order-buttons .confirm').addClass('hide');

                localStorage.removeItem('packet_selection');
            }

            $('body').removeClass('registering_order');
        });

    });

    $('.templates .choose').click(function (e) {
        e.preventDefault();
        const $template = $(this).parents('.single-template');
        const template_id = $template.attr('id').split('-')[1];

        $('#section-1').find('.selected').removeClass('selected');
        $template.addClass('selected');
        $('input[name="template_id"]').val(template_id);
        $('.order-buttons .forward').removeClass('locked');
    });

    $('.templates .clear-selection').click(function (e) {
        e.preventDefault();
        const $template = $(this).parents('.single-template');

        $template.removeClass('selected');
        $('input[name="template_id"]').val('');
        $('.order-buttons .forward').addClass('locked');
    });


    $('#show_server_bill').on('mouseup', function (e) {
        e.preventDefault();
        if (server_bill) {
            const win = window.open("","_blank");
            let html = '';

            html += '<html>';
            html += '<body style="margin:0!important">';
            html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+encodeURI(server_bill.file)+'" type="application/pdf" />';
            html += '</body>';
            html += '</html>';

            setTimeout(() => {
                win.document.write(html);
            }, 0);

        }
    });

    $('#download_server_bill').click(function (e) {
        e.preventDefault();
        if (server_bill) {
            const linkSource = `data:application/pdf;base64,${encodeURI(server_bill.file)}`;
            const downloadLink = document.createElement("a");
            const fileName = "Arve_"+server_bill.bill_nr+".pdf";

            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        }
    });

    $('.gallery-close-button').click(function (e)
    {
        e.preventDefault();
        $.fancybox.close();
    });

    $('.gallery-show-example-button').click(function (e) {
        e.preventDefault();
        const template_id = $(this).attr('id').replace('example-button-', '');

        let example_url = $('#'+template_id+' .zoom-link').data('example');

        window.open(example_url, '_blank');
    });

    $('.gallery-select-button').click(function (e)
    {
        e.preventDefault();
        const template_id = $(this).attr('id').replace('select-button-', '');
        $('#'+template_id+' .choose').click();
        //$('.gallery-select-button').addClass('hide');
        //$('.gallery-clear-button').removeClass('hide');
        $.fancybox.close();
    });

    $('.gallery-clear-button').click(function (e)
    {
        e.preventDefault();
        const template_id = $(this).attr('id').replace('clear-button-', '');
        $('#'+template_id+' .clear-selection').click();
        //$('.gallery-select-button').removeClass('hide');
        //$('.gallery-clear-button').addClass('hide');
        $.fancybox.close();
    });

    $('.confirm-campaign-code').click(function (e) {
        e.preventDefault();

        let campaign_code = $(".campaign-code-field").val();

        let data = {
            action: 'validate_campaign_code',
            campaign_code: campaign_code,
        };

        $.post(myAjax.ajaxurl, data, function(response) {
            const res = JSON.parse(response);

            if (res.status)
            {
                const discount = res.discount;

                let total_price = $("#overview-total-price").html().replace('€', '');
                total_price = parseFloat(total_price);

                let new_price = total_price - (total_price * (discount / 100));

                $('#overview-lowered-price').html(new_price.toFixed(2)+'€');
                $('#overview-total-price').html('<span class="original_price">'+total_price.toFixed(2)+'€</span>');

                $('input[name="campaign_code"]').val(campaign_code);
                orderData['campaign_code'] = campaign_code;

                $('.campaign-code-inserted').removeClass('hide');
                $('.lowered-price-item').removeClass('hide');
                $('.campaign-code-insert').addClass('hide');
                $('.campaign-code-inserted .campaign-code').html("-"+discount+"% ("+campaign_code+")");
                $('.campaign-code-container .error').addClass('hide');
                $('.packet_price_container').addClass('campaign-validated');
            } else {
                $('.campaign-code-container .error').removeClass('hide');
            }
        });
    });

    $('.remove-campaign-code').click(function (e) {
        e.preventDefault();

        $(".campaign-code-field").val('');
        $('.campaign-code-insert').removeClass('hide');
        $('.campaign-code-inserted').addClass('hide');
        $('.lowered-price-item').addClass('hide');
        $('.packet_price_container').removeClass('campaign-validated');

        $('input[name="campaign_code"]').val('');
        orderData['campaign_code'] = '';

        let total_price = $("#overview-total-price .original_price").html().replace('€', '');
        total_price = parseFloat(total_price);

        $('#overview-total-price').html(total_price.toFixed(2)+'€');
    });




    /********************* FORM ACTIONS *************************/

    $("#order-form").bind("keypress", function(e) {
        if (e.keyCode === 13) {
            return false;
        }
    });

    $("#order-form").submit(function (e) {
        e.preventDefault();
        console.log('validated');
        const formData = $(this).serializeArray();

        if ($(this).hasClass('locked')) {
            return;
        }

        window.orderData = {};

        for(let index in formData) {
            const item = formData[index];
            orderData[item.name] =  item.value;
        }

        let additional_data = {};

        let template_data = {
            action: 'template_image_url',
            template_id: orderData['template_id']
        };

        $.post(myAjax.ajaxurl, template_data, function(response) {
            const res = JSON.parse(response);

            if (res.status) {

                additional_data['template_image_url'] = res.url;

                if (orderData['domain'] !== '') {

                    let domain_data = {
                        action: 'domain_extension_price',
                        extension: orderData['domain_end']
                    };

                    $.post(myAjax.ajaxurl, domain_data, function(response) {
                        const res = JSON.parse(response);

                        if (res.status) {

                            additional_data['domain_price'] = res.price;
                            generateOverview(orderData, additional_data);
                        }
                    });

                } else {
                    generateOverview(orderData, additional_data);
                }
            }
        });


    });



    /** VALIDATION ACTIONS */


    //$(".registry-input").on('focusout')

    $("#section-2").click(function (e){
       if($(this).hasClass('active-section')){
           validateSection(2, false);
       }
    });


    function companyReqistrySearch() {

        if ($('.reg-response').hasClass('active')) {

            const $autocomplete = $('.reg-response ul');
            const $selected_li = $autocomplete.find('.selected');

            if ($selected_li.length) {
                $selected_li.click();
            } else {
                const $first_li = $autocomplete.find('.registry-autocomplete-item').first();

                if ($first_li.length) {
                    $first_li.click();
                }
            }
        } else {
            enter_reqistry_value();
        }
    }

    $("#registry").on('focusin', function (e) {
        $(this).addClass('search-active');
    });

    $("#registry").on('focusout', function (e) {
        e.preventDefault();
   // $("#registry").focusout(function (e) {

        if($(this).val() === '') {
            return false;
        }

        if($(this).hasClass('search-active')) {
            $(this).removeClass('search-active');
            companyReqistrySearch();
        }

    });

    let wait;

    $("#registry").keyup(function (e) {
        if($(this).val() === '') {
            return false;
        }

        if (e.keyCode === 13) {
            //enter_reqistry_value();

            if($(this).hasClass('search-active')) {
                $(this).removeClass('search-active');
                companyReqistrySearch();
            }

            return false;
        }

        if($('.reg-response').hasClass('active')) {
            if (e.keyCode <= 40 && e.keyCode >= 37){

                const $autocomplete = $('.reg-response ul');
                const isSelected = $autocomplete.find('.selected').length;

                if (e.keyCode === 38) { // up
                    if (isSelected) {
                        const $selected_li = $autocomplete.find('.registry-autocomplete-item.selected');
                        if ($selected_li.prev().length) {
                            $selected_li.removeClass('selected');
                            $selected_li.prev().addClass('selected');
                        }
                    } else {
                        $autocomplete.find('.registry-autocomplete-item').first().addClass('selected');
                    }
                }

                if (e.keyCode === 40) { // down
                    if (isSelected) {
                        const $selected_li = $autocomplete.find('.registry-autocomplete-item.selected');
                        if ($selected_li.next().length) {
                            $selected_li.removeClass('selected');
                            $selected_li.next().addClass('selected');
                        }
                    } else {
                        $autocomplete.find('.registry-autocomplete-item').first().addClass('selected');
                    }
                }

                return false;
            }
        }


        clearTimeout(wait);
        let $this = $(this);
        wait = setTimeout(function () {

            if (!$.isNumeric($this.val())) {
                let data = {
                    action: 'registry_recommendations',
                    registry: $this.val()
                };

                $.post(myAjax.ajaxurl, data, function(response) {
                    const res = JSON.parse(response);
                    if (res.status) {
                        let selection_html = "";

                        for (let i = 0; i < res.data.length; i++ ) {
                            const company = res.data[i];
                            console.log(company);
                            selection_html += '<li class="registry-autocomplete-item" id="reg-'+company.registrikood+'">'+company.nimi+'</li>';
                        }

                        $('.reg-response>ul').html(selection_html);
                        $('.reg-response').addClass('active');

                        setTimeout(function () {
                            $(".registry-autocomplete-item").bind('click', function () {
                                const code = $(this).attr('id').split('-')[1];
                                const name = $(this).text();

                                $("#registry").val(name);
                                send_registry(name, code);
                            });
                        },10);

                    } else {
                        $('.reg-response').removeClass('active');
                    }
                });
            }
            $('.reg-response').removeClass('active');
        },300)
    });

    //$("#registry").focusout(function (e) {

        /*if($('.reg-response').hasClass('active')) {
            return false;
        }*/

        /*setTimeout(function () {
            $('.reg-response').removeClass('active');
            return;


        }, 500);*/
/*
        const value = $("#registry").val();

        let last_check = false;

        if ($.isNumeric(value)){
            if ($('#registry_code_fixed').text() !== value)
                last_check = true;
        } else {
            if ($('#company_name_fixed').text() !== value)
                last_check = true;
        }
*/
        /*if(last_check)
            enter_reqistry_value();*/
    //});

    $("#company_info_block input").focusout(function (e) {

        if ($(this).val() === "") {
            $(this).addClass('not-validated');

            const $error =  $('#'+$(this).attr('name')+'_error');
            $error.removeClass('hide');
            $error.prev().removeClass('hide');

            console.log($(this).attr('name'));
            console.log($error);

        } else {
            if ($(this).hasClass('not-validated')) {
                $(this).removeClass('not-validated');

                const $error =  $('#'+$(this).attr('name')+'_error');

                $error.addClass('hide');
                $error.prev().addClass('hide');
            }
        }
    });

    $("#company_info_block input").focusin(function (e) {
        if ($(this).hasClass('not-validated')) {
            $(this).removeClass('not-validated');
            const $error =  $('#'+$(this).attr('name')+'_error');

            $error.addClass('hide');
            $error.prev().addClass('hide');
        }
    });

    $("#domain_selection_block .radio").click(function (e) {
        if ($(this).parent('div').hasClass('not-validated')) {
            $(this).parent('div').removeClass('not-validated');
        }
    });

    $("input[name='domain']").focusin(function (e) {
        $(this).removeClass('not-validated');
    });

    $("input[name='domain']").keyup(function (e) {
        clearTimeout(wait);
        let $this = $(this);
        wait = setTimeout(function () {
            let domain = $this.val();
            domain += '.'+$("select[name='domain_end']").val();
            validateDomain(domain);
            return false;
        },200)
    });

    $("input[name='domain']").focusout(function (e) {
        let domain = $(this).val();

        if (domain) {
            domain += '.'+$("select[name='domain_end']").val();
            validateDomain(domain);
        } else {
            $(this).addClass('not-validated');
            $(".domain-error-notice").addClass("hide");
        }
    });

    $("select[name='domain_end_mobile']").change(function () {
        if ($("select[name='domain_end']").val() !== $("select[name='domain_end_mobile']").val()) {
            $("select[name='domain_end']").val($(this).val());
            $("select[name='domain_end']").change();
        }
    });

    $("select[name='domain_end']").change(function () {
        if ($("select[name='domain_end']").val() !== $("select[name='domain_end_mobile']").val()) {
            $("select[name='domain_end_mobile']").val($(this).val());
        }
        let domain = $("input[name='domain']").val();
        domain += '.'+$(this).val();
        validateDomain(domain);
    });


    $(".domain-existance input").change(function () {

        let id = $(this).attr('id');

        if (id === 'domain-yes') {
            $(".domain-input-container").removeClass('hide');
        } else {
            $(".domain-input-container").addClass('hide');
        }
    });

    $(".privicy-policy").scroll(function (e) {
        let elem = $(e.currentTarget);

        if ((elem[0].scrollHeight - elem.scrollTop()) - 10 < elem.outerHeight()) {
            $(".scroll-required").prop("disabled", false);
            $(".scroll-required").removeClass("locked");
            $(".scroll-required-label").removeClass("locked");
        }
    });

    $("#ch1, #ch2").change(function () {
        if (validateSection(3)) {
            $('.order-buttons .confirm').removeClass('locked');
            $('input[name="ch1"]').removeClass('not-validated');
            $('.fields-not-validated-container').addClass('hide');
        }
        else {
            $('.order-buttons .confirm').addClass('locked');
        }

    });

    /** FUNCTIONS */

    function enter_reqistry_value() {
        clearTimeout(wait);
        const value = $("#registry").val();

        let name = '';
        let code = 0;

        if ($.isNumeric(value)){
            code = value;
        } else {
            name = value;
        }

        $('.registry-info').text('-');
        $('.company-info-inputs input').val('');

        send_registry(name, code);
        return false;
    }

    let registry_validated = false;

    function send_registry(name, code) {

        if (name === "" && code === 0) {
            $("#company_info_block").addClass('hide');
            $("#domain_selection_block").addClass('hide');
            $('.order-buttons .forward').addClass('locked');
            return false;
        }

        console.log(name);
        console.log(code);

        let data = {
            action: 'registry',
            name,
            code
        };

        const $req_response = $('.reg-response');

        if ($req_response.hasClass('active')) {
            $req_response.removeClass('active');
        }

        $.post(myAjax.ajaxurl, data, function(response) {
            const res = JSON.parse(response);

            if (res.status) {

                for (let property in res.data) {
                    if (res.data.hasOwnProperty(property)) {
                        $("#"+property+"_fixed").text(res.data[property]);

                        $('input[name="'+property+'"]').val(res.data[property]);
                        console.log($('input[name="'+property+'"]'));

                        const $input = $("#"+property+"-input");

                        if ($input.length) {
                            $input.val(res.data[property]);
                            $input.removeClass('hide');
                        }
                    }
                }

                $("#registry").val(res.data['company_name']);
                clearErrors();
                validateSection(2);
                registry_validated = true;
                $("#company_info_block").removeClass('hide');
                $("#domain_selection_block").removeClass('hide');

            } else {
                $("#company_info_block").addClass('hide');
                $("#domain_selection_block").addClass('hide');
            }
        });

    }

    let domain_validated = false;

    function validateDomain (domain) {

        let data = {
            action: 'domain_validator',
            domain
        };

        $.post(myAjax.ajaxurl, data, function(response) {
            const res = JSON.parse(response);

            console.log(res);

            if (!res.status) {
                $("#domain-owned").prop("disabled", true);
                $(".domain-owned").addClass("locked");
                $("#domain-owned").prop("checked", false);

                domain_validated = true;
                $(".domain-error-notice").addClass("hide");
                if (validateSection(2))
                    $('.order-buttons .forward').removeClass('locked');
            } else {
                $("#domain-owned").prop("disabled", false);
                $(".domain-owned").removeClass("locked");

                domain_validated = false;
                $(".domain-error-notice").removeClass("hide");

                $('.order-buttons .forward').addClass('locked');
            }
        });

    }

    function validateSection(section_id, errors = true) {

        console.log('validate', section_id);

        if (section_id === 1) {
            if ($('input[name="template_id"]').val() !== '')
                return true;

        } else if (section_id === 2) {

            if (
                ((domain_validated === true && $('#domain-yes').is(":checked") ) || $('#domain-no').is(":checked") ) &&
                $('input[name="client_name"]').val() !== '' &&
                $('input[name="contact_phone"]').val() !== '' &&
                $('input[name="email"]').val() !== '' &&
                ValidateEmail($('input[name="email"]').val())
            ) {
                console.log('Valid');
                $('.order-buttons .forward').removeClass('locked');
                if(errors) {
                    $('.fields-not-validated-container').addClass('hide');
                    clearErrors();
                }
                return true;
            } else {
                let text = '';
                if(registry_validated) {
                    if(!$('#domain-yes').is(":checked") && !$('#domain-no').is(":checked")){
                        if(errors) {
                            text += '<p>Palun kinnitage kodulehe aadressi olemasolu!</p>';
                            $('.domain-existance').addClass('not-validated');
                        }
                    }

                    if (($('#domain-yes').is(":checked")) && $('input[name="domain"]').val() === '') {
                        if(errors) {
                            text += '<p>Palun sisestage kodulehe aadress!</p>';
                            $('input[name="domain"]').addClass('not-validated');
                        }
                    }

                    if ($('input[name="client_name"]').val() === '') {
                        if(errors) {
                            text += '<p>Palun sisestage nimi!</p>';
                            $('input[name="client_name"]').addClass('not-validated');
                        }
                    }

                    if ($('input[name="contact_phone"]').val() === '') {
                        if(errors) {
                            text += '<p>Palun sisestage mobiiltelefon!</p>';
                            $('input[name="contact_phone"]').addClass('not-validated');
                        }
                    }

                    if ($('input[name="email"]').val() === '') {
                        if(errors) {
                            text += '<p>Palun sisestage e-mail!</p>';
                            $('input[name="email"]').addClass('not-validated');
                        }
                    }
                }else{
                    if($('input[name="registry"]').val() === ''){
                        if(errors) {
                            text += '<p>Palun sisestage ettevõtte ärinimi või registrikood!</p>';
                            $('input[name="registry"]').addClass('not-validated');
                        }
                    }
                }

                if(text.length > 0) {
                    if(errors) {
                        text = '<p>Edasiliikumiseks täida kõik nõutavad väljad</p>' + text;
                        $('.fields-not-validated-container').html(text);
                    }
                }

                $('.order-buttons .forward').addClass('locked');

            }

        } else if (section_id === 3) {
            if ($('input[name="ch1"]:checked').length > 0)
                return true;
        }

        return false;
    }

    function ValidateEmail(mail)
    {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
            return true
        return false
    }


    function generateOverview(order_data, additional_data) {


        console.log(additional_data);


        /** template info */

        $('#selected_template').css("background-image", "url('"+additional_data['template_image_url']+"')");

        /**packet info*/

        const packet_name = order_data['packet_slug']+" <span class=\"small\">("+order_data['packet_price']+"€)</span>";
        $('#selected-packet-name').html(packet_name);

        let additional_price = 0;
        if (order_data['additional_services'] !== '') {
            let addons_data = JSON.parse(order_data['additional_services']);
            let addons_html = '';

            for(let addon_index in addons_data) {
                const addon = addons_data[addon_index];
                addons_html += '<li>' + addon.label + '</li>';
                additional_price += parseFloat(addon.price);
            }
            $('#selected-addon-names').html(addons_html);
            $('.selected-addon-container').removeClass('hide');
        } else {
            $('.selected-addon-container').addClass('hide');
        }

        let total_price = parseFloat(order_data['packet_price'])+parseFloat(additional_price);
        $("#overview-total-price").html(total_price.toFixed(2)+'€');


        /**registry info*/

        $('#company_name_fixed_selected').html(order_data['company_name']);
        $('#registry_code_fixed_selected').html(order_data['registry_code']);

        if(order_data['kmkr_number'] !== '') {
            $('#kmkr_number_fixed_selected').html(order_data['kmkr_number']);
        } else {
            $('#kmkr_number_fixed_selected').html('-');
        }

        $('#address_fixed_selected').html(order_data['address']);
        $('#region_fixed_selected').html(order_data['region']);
        $('#postal_index_fixed_selected').html(order_data['postal_index']);

        $('#address_modified_selected').html(order_data['address_modified']);
        $('#region_modified_selected').html(order_data['region_modified']);
        $('#postal_index_modified_selected').html(order_data['postal_index_modified']);

        $('#contact_name_selected').html(order_data['client_name']);
        $('#contact_phone_selected').html(order_data['contact_phone']);
        $('#contact_email_selected').html(order_data['email']);

        /** email notification info */
        $('#notification_email_selected').html(order_data['email']);

        /**domain info*/

        if (order_data['domain'] !== "") {
            $('.selected_domain').html(order_data['domain']+'.'+order_data['domain_end']);
            $('#selected_domain_price').html(additional_data['domain_price']);
            $('#ch2').removeClass('hide');
            $('label[for="ch2"]').removeClass('hide');
            $('.domain-selection-notice-container').addClass('hide');
        } else {
            $('.selected_domain').html("-");
            $('#selected_domain_price').html('alates 4.50');
            $('#ch2').addClass('hide');
            $('label[for="ch2"]').addClass('hide');
            $('.domain-selection-notice-container').removeClass('hide');
        }

    }

    function generatePaymentPage(data) {

        $('#server_contract_nr').html(data.contract_nr);
        $('#server_contract_date').html(data.date);
        $('#server_price').html(data.bill.total_price);

        let bank_links_html = '';
        for (let i = 0; i < data.bank_links.length; i++) {
            const bank = data.bank_links[i];
            bank_links_html += '<a href="'+bank.url+'"><img src="'+bank.image+'" alt="'+bank.name+'"/></a>'
        }

        $('#server_bank_links').html(bank_links_html);
        $('#server_bill_nr').html(data.bill.bill_nr);

        window.server_bill = data.bill;
    }

});